import { useQuery } from '@tanstack/react-query';
import { DriveRequests } from 'src/requests/drive';
import { QueryKey, queryRetry } from 'src/utils/react-query';

export const useDriveContentQuery = (folderId?: string) => {
  const queryKey = [QueryKey.DRIVE, folderId];
  const { data: driveContents, isLoading } = useQuery(
    queryKey,
    () => DriveRequests.getContents({ parent: folderId }),
    {
      keepPreviousData: true,
      retry: queryRetry,
      refetchOnWindowFocus: false,
    },
  );
  return {
    driveContents,
    isDriveContentLoading: isLoading,
  };
};
